import { type ReactNode } from 'react'
import { Typography as AntdTypography, type TypographyProps as AntdTypographyProps } from 'antd'

import { Link } from './Link'
import { Paragraph } from './Paragraph'
import { Text } from './Text'
import { Title } from './Title'

interface TypographyProps extends AntdTypographyProps {
  children: ReactNode
}

export function Typography({ children }: TypographyProps) {
  return <AntdTypography>{children}</AntdTypography>
}

Typography.Link = Link
Typography.Paragraph = Paragraph
Typography.Text = Text
Typography.Title = Title
